import { useState } from 'react'
import type { MappingPlan } from './reportTemplatesApi'

export default function TemplateMappingModal({ plan, onConfirm, onCancel }: {
  plan: MappingPlan
  onConfirm: (mapping: Record<string, number>) => void
  onCancel: () => void
}) {
  const [choices, setChoices] = useState<Record<string, number>>(() =>
    Object.fromEntries(plan.ambiguous.map((a) => [a.sourceType, a.candidates[0].id])),
  )
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/30">
      <div className="bg-white rounded-2xl p-6 w-full max-w-md">
        <h3 className="font-semibold text-[#1B2559] mb-2">Associer les sources</h3>
        <p className="text-sm text-[#8B8FA7] mb-4">Ce projet a plusieurs sources d’un même type. Choisis laquelle utiliser.</p>
        {plan.ambiguous.map((a) => (
          <label key={a.sourceType} className="block mb-3 text-sm">
            <span className="text-[#1B2559] font-medium">{a.sourceType}</span>
            <select
              aria-label={a.sourceType}
              value={choices[a.sourceType]}
              onChange={(e) => setChoices((c) => ({ ...c, [a.sourceType]: Number(e.target.value) }))}
              className="mt-1 w-full bg-[#F4F5FA] border border-[#E2E4ED] rounded-xl px-3 py-2"
            >
              {a.candidates.map((c) => <option key={c.id} value={c.id}>{c.label}</option>)}
            </select>
          </label>
        ))}
        {plan.missing.length > 0 && (
          <p className="text-xs text-[#B0B4C5] mb-4">Sans source dans ce projet : {plan.missing.join(', ')} — ces widgets seront vides.</p>
        )}
        <div className="flex justify-end gap-2 mt-2">
          <button onClick={onCancel} className="px-4 py-2 text-sm text-[#8B8FA7]">Annuler</button>
          <button onClick={() => onConfirm(choices)} className="px-4 py-2 bg-[#6366F1] text-white text-sm rounded-xl">Créer le rapport</button>
        </div>
      </div>
    </div>
  )
}
